import React from 'react';

// react-bootstrap components
import { Container, Row, Col } from "react-bootstrap";

import { useAppState } from "../../state";

import GlobalProductsPanel from "./GlobalProductsPanel";

import './ProductsPage.scss';


const GlobalProductsPage = (props) => {
    const { user, app, onAppStateRefresh } = useAppState();
 
    return (
        <>
            <Container fluid id="globalProductPage">

                <Row>
                    <Col md="12" >                        
                        <div className="bg-white p-2 border-0 card">
                            <GlobalProductsPanel />
                        </div>                       
                    </Col>
                </Row>

            </Container>
        </>
    );
};

export default GlobalProductsPage;
